var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHabitsSodas = function SvgHabitsSodas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f78f8f",
    d: "M65.5 28.885h-8.882c-3.896-5.016-9.895-8.238-16.618-8.238s-12.722 3.223-16.618 8.238H14.5v27.138h8.882c3.896 5.016 9.895 8.238 16.618 8.238s12.722-3.223 16.618-8.238H65.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c74343",
    strokeMiterlimit: 10,
    d: "M65.5 28.885h-8.882c-3.896-5.016-9.895-8.238-16.618-8.238s-12.722 3.223-16.618 8.238H14.5v27.138h8.882c3.896 5.016 9.895 8.238 16.618 8.238s12.722-3.223 16.618-8.238H65.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1ebf2",
    d: "M22 76.5c-1.93 0-3.5-1.57-3.5-3.5V53.5h43V73c0 1.93-1.57 3.5-3.5 3.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M58 77H22c-2.206 0-4-1.794-4-4V53h44v20c0 2.206-1.794 4-4 4M19 54v19c0 1.654 1.346 3 3 3h36c1.654 0 3-1.346 3-3V54z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd5f2",
    d: "M19.6 72.5c-2.811 0-5.1-2.393-5.1-5.331V22.891c0-3.529 1.623-6.883 4.339-8.977L24.573 9.5h30.854l5.734 4.415c2.717 2.094 4.339 5.448 4.339 8.977V67.17c0 2.938-2.289 5.331-5.1 5.331H19.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b75a1",
    d: "M60.4 73H19.6c-3.088 0-5.6-2.616-5.6-5.831V22.891c0-3.681 1.695-7.185 4.534-9.373L24.403 9h31.194l5.869 4.519C64.305 15.707 66 19.21 66 22.891v44.278C66 70.384 63.488 73 60.4 73M24.744 10l-5.599 4.311c-2.595 2-4.145 5.208-4.145 8.581V67.17c0 2.663 2.063 4.83 4.6 4.83h40.8c2.537 0 4.6-2.167 4.6-4.831V22.891c0-3.373-1.549-6.581-4.145-8.581L55.256 10z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1ebf2",
    d: "M24.5 9.5c-1.652 0-3-1.348-3-3s1.348-3 3-3h31c1.652 0 3 1.348 3 3s-1.348 3-3 3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M55.5 10h-31C22.57 10 21 8.43 21 6.5S22.57 3 24.5 3h31C57.43 3 59 4.57 59 6.5S57.43 10 55.5 10m-31-6C23.122 4 22 5.122 22 6.5S23.122 9 24.5 9h31C56.878 9 58 7.878 58 6.5S56.878 4 55.5 4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeea3",
    d: "m30.094 60.5 6.911-17h-8.894l8.693-22h14.232l-7.899 15h8.751L30.6 60.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#967a44",
    d: "M30.826 61h-1.475l6.912-17h-8.886l9.089-23h15.399l-7.898 15H53zm-1.979-18h8.902l-6.522 16.042L50.777 37H42.31l7.898-15H37.145z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.5 64.5a.5.5 0 0 1-.5-.5V22.984c0-2.045.737-4.022 2.077-5.567l2.19-2.527a.501.501 0 0 1 .756.656l-2.19 2.527A7.497 7.497 0 0 0 21 22.984V64a.5.5 0 0 1-.5.5"
  })));
};
export default SvgHabitsSodas;